import React, { useState, useEffect } from "react";
import useSlideCount from "./useSlideCount";
import axios from "axios";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FiChevronLeft, FiChevronRight, FiArrowRight } from "react-icons/fi";
import ProductCard from "../ProductCard";
import { MyDomain } from "../../App";

function mapProduct(p) {
  const hasDiscount = !!(
    p.priceAfterDiscount &&
    p.price &&
    p.priceAfterDiscount < p.price
  );
  const discountPercent =
    p.discount ||
    (hasDiscount
      ? Math.round((1 - p.priceAfterDiscount / p.price) * 100)
      : null);
  return {
    id: p.id,
    name: p.name,
    image: p.image
      ? p.image.startsWith("http")
        ? p.image
        : `${MyDomain}${p.image}`
      : "",
    price: hasDiscount ? p.priceAfterDiscount : p.price,
    originalPrice: hasDiscount ? p.price : null,
    hasDiscount,
    discountPercent,
    isNew: p.isNew === "Yes",
    gender: p.gender || "",
    deal: p.deal || "",
  };
}

function ViewAllButton({ to }) {
  const [hovered, setHovered] = useState(false);
  return (
    <Link
      to={to}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "8px 18px",
        borderRadius: 24,
        border: `1.5px solid ${hovered ? "#e11d48" : "rgba(0,0,0,0.15)"}`,
        background: hovered ? "#e11d48" : "transparent",
        color: hovered ? "#fff" : "#333",
        fontSize: 13,
        fontWeight: 600,
        textDecoration: "none",
        transition: "all 0.2s",
        whiteSpace: "nowrap",
      }}
    >
      View All
      <FiArrowRight
        size={14}
        style={{
          transition: "transform 0.2s",
          transform: hovered ? "translateX(3px)" : "translateX(0)",
        }}
      />
    </Link>
  );
}

function ArrowBtn({ direction, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        [direction === "prev" ? "left" : "right"]: -18,
        zIndex: 10,
        background: hovered ? "#e11d48" : "#ffffff",
        border: `1px solid ${hovered ? "#e11d48" : "rgba(0,0,0,0.12)"}`,
        borderRadius: "50%",
        width: 36,
        height: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: hovered ? "white" : "#333",
        transition: "background 0.2s, border 0.2s, color 0.2s",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {direction === "prev" ? (
        <FiChevronLeft size={18} />
      ) : (
        <FiChevronRight size={18} />
      )}
    </button>
  );
}


export default function MPNewDubaiProductsCarousel() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${MyDomain}Products2/GetRandomNewDubaiPerfumes`)
      .then((res) => setProducts(res.data.map(mapProduct)))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const slidesToShow = useSlideCount();
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 480,
    slidesToShow,
    slidesToScroll: 1,
    arrows: slidesToShow > 1,
    prevArrow: <ArrowBtn direction="prev" />,
    nextArrow: <ArrowBtn direction="next" />,
    dotsClass: "slick-dots",
    appendDots: (dots) => (
      <div style={{ bottom: -28 }}>
        <ul style={{ margin: 0, padding: 0 }}>{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div
        style={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          background: "rgba(0,0,0,0.18)",
          margin: "0 3px",
          transition: "background 0.2s",
        }}
      />
    ),
  };

  if (loading)
    return (
      <div className="product-carousel-section">
        <div style={{ marginBottom: 32 }}>
          <div
            style={{
              width: 180,
              height: 22,
              borderRadius: 6,
              background: "#e8e8e8",
              marginBottom: 10,
            }}
          />
          <div
            style={{
              width: 40,
              height: 3,
              borderRadius: 2,
              background: "#e8e8e8",
            }}
          />
        </div>
        <div className="shimmer-cards" style={{ display: "flex", gap: 20 }}>
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              style={{
                flex: 1,
                borderRadius: 14,
                overflow: "hidden",
                border: "1px solid rgba(0,0,0,0.08)",
              }}
            >
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1/1",
                  background: "#f0f0f0",
                  animation: "shimmer 1.4s infinite",
                }}
              />
              <div
                style={{
                  padding: "13px 14px 15px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 8,
                }}
              >
                <div
                  style={{
                    width: "75%",
                    height: 14,
                    borderRadius: 4,
                    background: "#ececec",
                  }}
                />
                <div
                  style={{
                    width: "40%",
                    height: 14,
                    borderRadius: 4,
                    background: "#ececec",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
        <style>{`
        @keyframes shimmer {
          0%   { opacity: 1; }
          50%  { opacity: 0.45; }
          100% { opacity: 1; }
        }
      `}</style>
      </div>
    );

  if (products.length === 0) return null;

  return (
    <div className="product-carousel-section">
      {/* Section header */}
      <div
        style={{
          marginBottom: 32,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <div>
          <h2
            style={{
              color: "#1a1a1a",
              fontSize: 22,
              fontWeight: 700,
              margin: 0,
              marginBottom: 6,
              letterSpacing: 0.3,
            }}
          >
            New Dubai Perfumes
          </h2>
          <div
            style={{
              width: 40,
              height: 3,
              background: "#e11d48",
              borderRadius: 2,
            }}
          />
        </div>

        <ViewAllButton to="/new-dubai-perfumes" />
      </div>

      {/* Carousel */}
      <div style={{ position: "relative" }}>
        <Slider {...sliderSettings}>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </Slider>
      </div>

      <style>{`
        .slick-dots li.slick-active div {
          background: #e11d48 !important;
        }
      `}</style>
    </div>
  );
}
